<template>
  <div>
    <v-btn
      color="primary"
      dark
      class="mr-5"
      v-if="customerId"
      :disabled="isAllTextFieldDisable"
      @click="selectRepairPriceItemsBtn"
    >
      選擇修改品項
    </v-btn>
    <v-dialog v-model="isShowEditCustomerRepairItemDialog" fullscreen persistent>
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ $t('common_edit') }}</span>
        </v-card-title>
        <v-data-table
          :headers="customerRepairItemDataTableHeaders"
          :items="computedCustomerRepairItems"
          class="elevation-1 ma-5 "
          :search="searchCustomerRepairItem"
          :loading-text="$t('common_get_data')"
          :no-data-text="$t('common_no_data')"
          :no-results-text="$t('common_no_results')"
          :footer-props="{
            'items-per-page-options': [30, 50, 100],
            'items-per-page-text': $t('item_rows_per_page'),
          }"
          :header-props="headerProps"
          v-model="selectCustomerRepairItems"
          item-key="Index"
          show-select
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>{{ $t('customer_repair_item_toolbar_title') }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="searchCustomerRepairItem"
                append-icon="mdi-magnify"
                :label="$t('customer_repair_item_search_label')"
                single-line
                hide-details
                clearable
              ></v-text-field>
            </v-toolbar>
          </template>
        </v-data-table>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            text
            @click="closeSelectCustomerRepairItems"
            :disabled="isAllTextFieldDisable"
          >
            {{ $t('common_cancel') }}
          </v-btn>
          <v-btn
            color="green darken-1"
            :disabled="selectCustomerRepairItems.length === 0"
            text
            @click="addSelectCustomerRepairItems"
          >
            {{ $t('common_confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { HttpUpdateCustomerRepair } from '@/js/http-Manager'
export default {
  name: 'SelectRepairPriceItem',
  data: () => ({
    searchCustomerRepairItem: '',
    isShowEditCustomerRepairItemDialog: false,
    customerRepairItems: [],
    selectCustomerRepairItems: []
  }),
  props: {
    isAllTextFieldDisable: {
      type: Boolean,
      default: false
    },
    customerId: {
      type: String
    }
  },
  mounted () {},
  watch: {},
  computed: {
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    },
    customerRepairItemDataTableHeaders () {
      return [
        { text: this.$t('customer_repair_item_new_number'), align: 'start', value: 'Number' },
        { text: this.$t('customer_repair_item_new_name'), align: 'start', value: 'Name' },
        {
          text: this.$t('customer_repair_item_new_warranty_period'),
          align: 'end',
          value: 'WarrantyPeriod'
        },
        { text: this.$t('customer_repair_item_new_price'), align: 'end', value: 'Price' },
        { text: '新品維修保固期數', align: 'end', value: 'RepairWarrantyPeriod' },
        { text: '新品維修價格', align: 'end', value: 'RepairPrice' },
        { text: this.$t('customer_repair_item_old_number'), align: 'start', value: 'OldNumber' },
        { text: this.$t('customer_repair_item_old_name'), align: 'start', value: 'OldName' },
        {
          text: this.$t('customer_repair_item_old_warranty_period'),
          align: 'end',
          value: 'OldWarrantyPeriod'
        },
        {
          text: this.$t('customer_repair_item_old_price'),
          align: 'end',
          value: 'OldPrice'
        },
        {
          text: '良品維修保固期數',
          align: 'end',
          value: 'OldRepairWarrantyPeriod'
        },
        {
          text: '良品維修價格',
          align: 'end',
          value: 'OldRepairPrice'
        },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false }
      ]
    },
    computedCustomerRepairItems () {
      let array = []
      if (this.customerRepairItems) {
        this.customerRepairItems.forEach((item, index) => {
          array.push({
            ...item,
            Index: index + 1
          })
        })
      }
      return array
    }
  },
  methods: {
    async selectRepairPriceItemsBtn () {
      await this.getCustomerRepairItems()
      this.isShowEditCustomerRepairItemDialog = true
    },
    closeSelectCustomerRepairItems () {
      this.selectCustomerRepairItems = []
      this.customerRepairItems = []
      this.isShowEditCustomerRepairItemDialog = false
    },
    addSelectCustomerRepairItems () {
      this.$emit('addSelectCustomerRepairItems', this.selectCustomerRepairItems)
      this.closeSelectCustomerRepairItems()
    },
    async getCustomerRepairItems () {
      let param = {
        customerId: this.customerId
      }
      let response = await HttpUpdateCustomerRepair.GetCustomerRepairItems(param)
      if (response && response.status === 200) {
        this.customerRepairItems = response.data.Data
      }
    }
  }
}
</script>
